




























































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ChargeSummaryDto } from '@/models/audit/ChargeSummaryDto';
import { AgentSummary } from '@/models/audit/AgentSummary';
import {
  DxDataGrid,
  DxColumn,  
  DxMasterDetail,
  DxSummary,
  DxTotalItem,
  DxLoadPanel,
  DxScrolling
} from 'devextreme-vue/data-grid';
import { DxSwitch } from 'devextreme-vue/switch';
import { MatterWorkMatterDto } from '@/models/matter-work/MatterWorkMatterDto';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { FeeTypeNameEnum } from '@/models/Fees/FeeTypeEnum';
import _ from 'lodash';
import ChargeDetail from './charge-detail.vue';
import { FeeSheetRuleDto } from '@/models/Fees/FeeSheetRuleDto';
import { FeeSheetTypeEnum } from '@/models/Fees/FeeSheetTypeEnum';
import { MatterOverage } from '@/models/MatterOverage';
import { OveragesTypeEnum } from '@/models/audit/OveragesTypeEnum';
import { AutoTextDataDto } from '@/models/auto-text/AutoTextDataDto';
import { FeeBudgetRuleDto } from '@/models/fee-budgets/FeeBudgetRuleDto';
import { AuditingService } from '@/service/AuditingService';
import { ManualCodeInvoiceLineItemDto } from '@/models/ManualCodeInvoiceLineItemDto';
import { MatterBestRulesForOverageDto } from '@/models/matter/MatterBestRulesForOverageDto';
import { ExecutiveSummaryDto } from '@/models/ExecutiveSummaryDto';
import { MattersService } from '@/service/MattersService';
import { ExecutiveSummaryTypeEnum } from '@/models/ExecutiveSummaryTypeEnum';
import { ExecutiveSummaryRequestEnum } from '@/models/ExecutiveSummaryRequestEnum';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxSwitch,
    DxMasterDetail,
    ChargeDetail,
    DxSummary,
    DxTotalItem,
    DxLoadPanel,
    DxScrolling
  }
})
export default class ChargeSummary extends Vue {
  $refs: Vue['$refs'] & {
    chargeSummaryGrid?: DxDataGrid;
  } = {};

  @Prop()
  matter!: MatterWorkMatterDto;

  get matterId(): Guid {
    return this.matter.MatterId;
  }

  get matterLineItems() : ManualCodeInvoiceLineItemDto[] {
    return this.matter.LineItems;
  }

  @Watch("matter.MatterId")
  async onMatterChanged() {
    this.matterIdChanged = true;
    this.currentFocusedPhaseType = "";
    this.updateSummary();
  }

  @Prop()
  phaseTypes!: PhaseTypeDto[];

  @Prop({ default: undefined })
  clientId!: Guid;

  @Prop()
  feeSheetRules!: FeeSheetRuleDto[];

  @Prop()
  feeBudgetRules!: FeeBudgetRuleDto[];

  @Prop()
  latestBatchIds!: Guid[];

  get activeBatchIds(): Guid[] {
    return this.latestBatchIds;
  }

  private get dxDataGrid() {
    return (this.$refs.chargeSummaryGrid as any).instance;
  }  

  fromExpandingCollapsingRow: boolean = false;
  currentFocusedPhaseType: string|undefined;
  autoTextData: AutoTextDataDto[] = [];
  dateFilter: any = (this.$options.filters as any);
  matterBestRuleForOverage: MatterBestRulesForOverageDto[] = [];
  auditingService: AuditingService;
  matterService: MattersService;

  constructor() {
    super();
    this.auditingService = new AuditingService();
    this.matterService = new MattersService();
    this.loadData(this.auditingService, this.matterService);   
  }

  async loadData(auditingService: AuditingService, matterService: MattersService) {
    this.updateSummary(matterService);
  }
  
  updateSummary(matterService: MattersService | undefined = undefined) {
    (this.matterService ? this.matterService: 
    (matterService ? matterService : new MattersService()))
    .getMatterBestRulesForOverage(this.matter.MatterId)
    .then(result => {
      this.matterBestRuleForOverage = result;
    });

    (this.matterService ? this.matterService: 
    (matterService ? matterService : new MattersService()))
    .getExecutiveSummaryData(this.matter.MatterId, ExecutiveSummaryRequestEnum.All)
    .then(result => {
      this.execSummary = result;
    });
  }

  updateSummaryWhenChanges(type : ExecutiveSummaryRequestEnum | undefined) {
    if(type != undefined) {
      this.matterService.getMatterBestRulesForOverage(this.matter.MatterId)
      .then(result => {
        this.matterBestRuleForOverage = result;
      });

      var execResult: ExecutiveSummaryDto[] = []
      this.matterService.getExecutiveSummaryData(this.matter.MatterId, type)
      .then(result => {
        execResult = result;

        if(type == ExecutiveSummaryRequestEnum.Infraction  || type == ExecutiveSummaryRequestEnum.All) {
          var phaseOverage = this.executiveSummary.filter(x => x.Type == ExecutiveSummaryTypeEnum.Phase);
          var analysisItem = this.executiveSummary.filter(x => x.Type == ExecutiveSummaryTypeEnum.AnalysisItem);

          this.executiveSummary.length = 0;
          this.executiveSummary = _.concat(phaseOverage, execResult, analysisItem);
        }
        if(type == ExecutiveSummaryRequestEnum.PhaseAnalysisItem || type == ExecutiveSummaryRequestEnum.All){
          var infractionOverage = this.executiveSummary.filter(x => x.Type == ExecutiveSummaryTypeEnum.Infraction);
          var phaseOverage = execResult.filter(x => x.Type == ExecutiveSummaryTypeEnum.Phase);
          var analysisItem = execResult.filter(x => x.Type == ExecutiveSummaryTypeEnum.AnalysisItem);

          this.executiveSummary.length = 0;
          this.executiveSummary = _.concat(phaseOverage, infractionOverage, analysisItem);
        }
      })
      .finally(() => {
        
      });
    }
  }

  onRowExpanded(e:any) {
    this.fromExpandingCollapsingRow = true;
  }

  onRowCollapsed(e:any) {
    let component =   e.component.instance();
    let chargeSummary = component.getDataSource().items();
    let summ = chargeSummary.find((item: ChargeSummaryDto) => item.PhaseTotal.PhaseType == e.key)

    if(summ.IsFocused){
      this.currentFocusedPhaseType = undefined;
      summ.IsFocused = false;
      component.saveEditData();
      this.$root.$emit("focused-phase-type", undefined);
    }

    this.fromExpandingCollapsingRow = true;
  }

  private onFocusedChanged(phaseType: string) {    
    if(phaseType) {
      this.currentFocusedPhaseType = phaseType;
      let chargeSummary = this.dxDataGrid.getDataSource().items()
      let filtered = chargeSummary.filter((item: ChargeSummaryDto) => item.PhaseTotal.PhaseType !== phaseType);

      filtered.forEach((item: ChargeSummaryDto) => {
        if(item.IsFocused) {
          item.IsFocused = false;
        }
      });
    }
    else {
      this.currentFocusedPhaseType = undefined;
    }

    this.dxDataGrid.saveEditData();
    this.$root.$emit("focused-phase-type", phaseType);
  }

  displayFormat(e:any){
    return (this.$options.filters as any).chargeTotalCurrency(e.value);
  }

  calculateTotals(options: any) {
      if (options.name === 'PhaseTypeSummary') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0;
        } else if (options.summaryProcess === 'calculate') {
          options.totalValue = options.totalValue + 0;
        }
      }
  }

  matterIdChanged: boolean = true;
  onContentReady(e: any) {
    if(this.matterIdChanged) {
      this.expandRowsInCurrentBatch(e.component);
    }
    else if(!this.fromExpandingCollapsingRow) {
      this.scrollToFocusedRow();
    }
  }

  scrollToFocusedRow() {
    let focusedPhase = document.getElementsByClassName('focused-phase')[0];
      if (focusedPhase) {
        setTimeout(() => {
          focusedPhase.scrollIntoView(true);
        },200)
      }
  }

  expandRowsInCurrentBatch(component: any) {    
      let items = component.getDataSource().items();

      let filteredItems = items.filter((element : any) => this.checkIfIsInCurrentBatch(element.BatchId));
      let notInBatch = items.filter((element : any) => !this.checkIfIsInCurrentBatch(element.BatchId))

      notInBatch.forEach((element : any) => {
          component.collapseRow(element.PhaseTotal.PhaseType);
      });

      filteredItems.forEach((element : any) => {
          component.expandRow(element.PhaseTotal.PhaseType);
      });

      //scrolls the element to the top unlike the navigateToKey
      let billedHere = document.getElementsByClassName('billed-here')[0];
      if (billedHere) {
          billedHere.scrollIntoView(true);
      }
    

      if(items && items.length > 0 && this.activeBatchIds && this.activeBatchIds.length > 0) {
        this.matterIdChanged = false;
      }    
  }

   onCellPrepared(e: any) {  
    if(e.rowType === 'data' && e.column.dataField == "PhaseType") { 
      e.cellElement.style['background-color'] = e.row.data.PhaseTotal.RgbHex;
    }

    if(e.rowType === 'data' && e.column.dataField == "PhaseTotal.Services" && e.row.data.ServiceOverageType && e.row.data.OverageInLatestBatch) {       
      e.cellElement.style['color'] = 'red';
      e.cellElement.style['font-weight'] = 'bold';
    }
  }

  onExecutiveSummaryCellPrepared(e: any) {  
    if(e.rowType === 'data' ) { 
      if(e.column.dataField == "Issue" && e.row.data.Type == ExecutiveSummaryTypeEnum.Phase) {
        e.cellElement.style['background-color'] = e.row.data.RGB;
      }

      if (e.row.data.Type == ExecutiveSummaryTypeEnum.AnalysisItem && !e.row.data.IssueInLatestBatch) {
        e.cellElement.style['background-color'] = '#f5f5f5';
      }
    }
  }
  executiveSummaryPhaseBorder(data: any) {
    if(data.Type == ExecutiveSummaryTypeEnum.Phase) {
      let colorVal = data.OverageType == 0 ? '#ffae42' : 'red';
      return {
      'border' : `solid 2px ${colorVal}`
      };
    }
  }

  get matterFeeSheetRules(): FeeSheetRuleDto[] {
    return this.feeSheetRules.filter(
      r =>        
        r.ClientId === this.matter.ClientId &&
        (r.Country == null || r.Country.CountryCode === this.matter.CountryCode)
    );
  }

  get matterFeeBudgetRules() {
    return this.feeBudgetRules.filter(r => r.MatterId === this.matterId);
  }

  matterOverages(): MatterOverage[] {
    let filteredRules = this.matterFeeSheetRules.filter(r => r.FilingTypes.length == 0 || r.FilingTypes.some(f => f.FilingTypeId == this.matter.FilingTypeId));    
    let lineItems = this.matterLineItems.filter(item => item.FeeType === FeeTypeNameEnum.Service);
    let groupedByAgent = _.groupBy(lineItems, i => i.AgentName);
    
    let matterOverages = _.flatMap(groupedByAgent, (linesByAgent, agentName) => {
      let groupedByPhase = _.groupBy(linesByAgent, i => i.AssignedPhaseTypeId);

      return _.flatMap(groupedByPhase, (lineItems, phaseTypeId) => {
        let overages: MatterOverage[] = [];
        let phaseType = this.phaseTypes.filter(t => t.PhaseTypeId === parseInt(phaseTypeId))[0];
        let lineItemsPhase = phaseType != null ?
                              (phaseType.IsBatched ?
                              lineItems.filter(i => this.activeBatchIds && this.activeBatchIds.includes(i.BatchId))
                              : lineItems) : [];

        if (phaseType != null && lineItemsPhase && lineItemsPhase.length > 0) {
          let phaseTypeId = phaseType.PhaseTypeId;
          let bestRule = this.matterBestRuleForOverage.find(m => m.AgentName == agentName && m.PhaseTypeId == phaseTypeId)

          if(bestRule) {
              let overage: MatterOverage = {
                AliasName: phaseType.PhaseName,
                RgbHex: phaseType.RgbHex,
                Total: bestRule.PhaseAgentTotal ? bestRule.PhaseAgentTotal : 0,
                RuleValue: bestRule.RuleType == FeeSheetTypeEnum.Cap ? 
                          (bestRule.CapAmount ? bestRule.CapAmount : 0) : 
                          (bestRule.TargetAmount ? bestRule.TargetAmount : 0),
                TargetOrCap: bestRule.RuleType,
                OverageType: bestRule.HardOrSoftOverage == 0 ? OveragesTypeEnum.SoftOverage : OveragesTypeEnum.HardOverage,
                AgentName: agentName,
                PhaseOrder: phaseType.PhaseOrder,
                OverageInLatestBatch : bestRule.OverageInLatestBatch
              };
              
              if(bestRule.FeeSheetRuleId) {
                if (overages.filter(mo => mo.AliasName == phaseType.PhaseName).length != 0) {
                  if (bestRule.RuleType == FeeSheetTypeEnum.Cap) {
                    overages = overages.filter(mo => mo.TargetOrCap != FeeSheetTypeEnum.Target && mo.AliasName != phaseType.PhaseName);
                    overages.push(overage);
                  }
                } else {
                  overages.push(overage);
                }
              }
              else{
                overages.push(overage);
              }
          }
        }

        return overages;
      });
    });

    return matterOverages;
  }


  private currentLineItems: ManualCodeInvoiceLineItemDto[] = [];
  
  execSummary: ExecutiveSummaryDto[] = [];
  get executiveSummary() : ExecutiveSummaryDto[] {
    return this.execSummary;
  }
  set executiveSummary(data: ExecutiveSummaryDto[]) {
    this.execSummary = data;
  }

  get chargeSummary(): ChargeSummaryDto[] {    
    let matterOverAges = this.matterOverages();
    this.currentLineItems = _.cloneDeep(this.matterLineItems);
    let latestBatchId = this.activeBatchIds;
    let groupedItems = _.groupBy(this.currentLineItems, i => i.AssignedPhaseName);      

    let result: ChargeSummaryDto[] = _.map(groupedItems, (phaseGroup, key) => {
      let agentSummaries: AgentSummary[] = [];
      let batchId : Guid = "";
      let agentGroups = _.groupBy(phaseGroup, g => g.AgentName);

      _.forEach(agentGroups, (lineItems) => {        
        let agentSumm: AgentSummary = {
          AgentName: lineItems[0].AgentName,
          Services: 0,
          Translations: 0,
          Expenses: 0,
          AgentJurisdiction: lineItems[0].AgentJurisdiction,
          AgentJurisdictionFree: lineItems[0].AgentJurisdictionFree,
          MatterId: this.matterId,
          PhaseTypeId: lineItems[0].AssignedPhaseTypeId,
          OverageInLatestBatch: false
        }

        let serviceLineItems = lineItems.filter(li => li.FeeType === FeeTypeNameEnum.Service)
        agentSumm.Services = serviceLineItems.reduce((sum, li) => sum + (li.IsExempt ? 0 : li.LineItemTotal), 0);
        agentSumm.Expenses = lineItems.filter(li => li.FeeType === FeeTypeNameEnum.Expense).reduce((sum, li) => sum + (li.IsExempt ? 0 : li.LineItemTotal), 0);
        agentSumm.Translations = lineItems.filter(li => li.FeeType === FeeTypeNameEnum.Translation).reduce((sum, li) => sum + (li.IsExempt ? 0 : li.LineItemTotal), 0);
        
        let overage = _.find(matterOverAges, item => item.AgentName === agentSumm.AgentName && item.AliasName === key);        
        if(overage) {
          agentSumm.OverageDetail = overage;
          agentSumm.OverageType = agentSumm.OverageDetail.OverageType;
          agentSumm.RuleType = agentSumm.OverageDetail.TargetOrCap;
          agentSumm.OverageInLatestBatch = overage.OverageInLatestBatch ? overage.OverageInLatestBatch : false;
        }
        
        let lineItem = lineItems.find(li => latestBatchId && latestBatchId.some(b => b == li.BatchId));
        if(lineItem != undefined) {
          batchId = lineItem.BatchId
        }        
        agentSummaries.push(agentSumm);
      });
      

      //for summary overage type
      let serviceWithOverages = agentSummaries.filter(item => item.OverageDetail);
      let summaryOverageType = undefined;
      if(serviceWithOverages && serviceWithOverages.length > 0) {
        summaryOverageType = _.find(serviceWithOverages, item => item.OverageType && item.OverageType === OveragesTypeEnum.HardOverage)
                              ? OveragesTypeEnum.HardOverage : OveragesTypeEnum.SoftOverage;
      }

      let services = _.sumBy(
        agentSummaries,
        i => i.Services
      );
      let expenses = _.sumBy(
        agentSummaries,
        i => i.Expenses
      );
      let translations = _.sumBy(
        agentSummaries,
        i => i.Translations
      );     

      let phaseType = _.find(this.phaseTypes, i => key === i.PhaseName);
      let phaseTypeName = key == null || key === 'null' ? 'Unassigned' : key;
      
      return {
        PhaseTotal: {
          Services: services,
          Expenses: expenses,
          Translations: translations,
          PhaseType: phaseTypeName,
          Total: services + expenses + translations,
          RgbHex: phaseType ? phaseType.RgbHex : undefined,
          PhaseOrder: phaseType ? phaseType.PhaseOrder : undefined
        },
        AgentSummaries: agentSummaries,
        RowCount: phaseGroup.length,
        BatchId: batchId,
        ServiceOverageType: summaryOverageType,
        PhaseOrder: phaseType ? phaseType.PhaseOrder : 0,
        IsFocused: this.currentFocusedPhaseType === phaseTypeName ? true : false,
        OverageInLatestBatch: agentSummaries.some(s => s.OverageInLatestBatch)
      };
    
    });

    this.fromExpandingCollapsingRow = false;
    // this.currentChargeSummary = result.sort((a, b) => a.PhaseOrder - b.PhaseOrder);

    return result.sort((a, b) => a.PhaseOrder - b.PhaseOrder);
  }

  private checkIfIsInCurrentBatch(batchId: Guid): boolean {
    return this.activeBatchIds && this.activeBatchIds.some(b => b === batchId);
  }

  private isInCurrentBatch(batchId: Guid): string {
    return this.checkIfIsInCurrentBatch(batchId) ? "bold" : "normal";        
  }

  private phaseTypeTemplate(container: any, options: any) {
    container.textContent = `${options.data.PhaseTotal.PhaseType} (${options.data.RowCount})`;
    container.className = `${this.checkIfIsInCurrentBatch(options.data.BatchId) ? 'billed-here': ''} ${options.data.IsFocused ? 'focused-phase': ''}`;
    container.style.fontWeight = this.isInCurrentBatch(options.data.BatchId);
  }

  private totalTemplate(container: any, options: any) {
    const filter = (this.$options.filters as any).chargeTotalCurrency;

    container.textContent = filter(options.data.PhaseTotal.Total, false);
  }

  private expensesTemplate(container: any, options: any) {
    const filter = (this.$options.filters as any).chargeTotalCurrency;

    container.textContent = filter(options.data.PhaseTotal.Expenses, false);
  }

  private translationsTemplate(container: any, options: any) {
    const filter = (this.$options.filters as any).chargeTotalCurrency;

    container.textContent = filter(options.data.PhaseTotal.Translations, false);
  }

  beforeDestroy(): void {
    this.$root.$off("process-auto-text-value", this.handleUserSettingChanged);
    this.$root.$off('updatenavmatters', this.updateSummaryWhenChanges)
  }

  async mounted(): Promise<void> {
    this.$root.$on("process-auto-text-value", this.handleUserSettingChanged);
    this.$root.$on('updatenavmatters', this.updateSummaryWhenChanges)
  }

  handleUserSettingChanged(done: any) {
    done(this.autoTextData);
  }

}
